export const FETCH_CAROUSEL_SLIDES = 'fetchCarouselSlides';
